import React, { FC, useCallback, useState } from 'react';
import { Switch } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { useApiError, useLoading } from '../../../../providers';
import { enableCampaign } from '../../CashbackService';
import { CampaignView } from '../../CashbackModel';
import { concatErrorMessages } from '../../../../utils';
import { useCommonStyles } from '../../../../styles';

interface Props {
  translation: any;
  campaign: CampaignView;
}

export const CampaignEnableSwitch: FC<Props> = ({ translation, campaign }) => {
  const commonClasses = useCommonStyles();
  const { setIsLoading } = useLoading();
  const { addError } = useApiError();
  const { enqueueSnackbar } = useSnackbar();
  const [status, setStatus] = useState(campaign.status);

  const handleSwitchChange = useCallback(
    async (event) => {
      event.stopPropagation();
      setIsLoading(true);
      try {
        const isEnabled = status === 'Active';
        await enableCampaign(campaign.id, !isEnabled);
        setStatus(isEnabled ? 'Inactive' : 'Active');
      } catch (error) {
        if (error.response.status === 401) {
          addError(error.response);
        } else {
          const message = concatErrorMessages(translation, error.response.data);
          enqueueSnackbar(message, { variant: 'error' });
        }
      } finally {
        setIsLoading(false);
      }
    },
    [campaign, setIsLoading, enqueueSnackbar, status, translation, addError],
  );

  return <Switch checked={status === 'Active'} classes={{ root: commonClasses.switchRoot }} onClick={handleSwitchChange} id={campaign.id.toString()} />;
};
